import {NavigateFunction} from 'react-router-dom';

export const canGoBack = () => {
  return window.history.state.idx !== 0;
};

export const navigateBackOrHome = (navigate: NavigateFunction) => {
  canGoBack() ? navigate(-1) : navigate('/home');
};
